// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  min-height: 100vh;
  background: var(--background);
  font-family: 'Inter', sans-serif;
  padding: 20px;
}

.content {
  max-width: 980px;
  margin: 24px auto;
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(0,0,0,0.06);
}

.mainTitle {
  margin-top: 0;
  color: var(--foreground);
}

.effectiveDate {
  color: var(--muted-foreground);
}

.section {
  margin-top: 12px;
}

.sectionTitle {
  color: var(--foreground);
  font-weight: 600;
}

.sectionText {
  color: var(--muted-foreground);
  line-height: 1.6;
}

.sectionText ul {
  margin: 8px 0;
  padding-left: 20px;
}

.sectionText li {
  margin-bottom: 4px;
}

.sectionText strong {
  color: var(--foreground);
  font-weight: 600;
}

.footerNote {
  color: #66788a;
  margin-top: 18px;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Privacy.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".container {\n  min-height: 100vh;\n  background: var(--background);\n  font-family: 'Inter', sans-serif;\n  padding: 20px;\n}\n\n.content {\n  max-width: 980px;\n  margin: 24px auto;\n  background: #fff;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 6px 24px rgba(0,0,0,0.06);\n}\n\n.mainTitle {\n  margin-top: 0;\n  color: var(--foreground);\n}\n\n.effectiveDate {\n  color: var(--muted-foreground);\n}\n\n.section {\n  margin-top: 12px;\n}\n\n.sectionTitle {\n  color: var(--foreground);\n  font-weight: 600;\n}\n\n.sectionText {\n  color: var(--muted-foreground);\n  line-height: 1.6;\n}\n\n.sectionText ul {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.sectionText li {\n  margin-bottom: 4px;\n}\n\n.sectionText strong {\n  color: var(--foreground);\n  font-weight: 600;\n}\n\n.footerNote {\n  color: #66788a;\n  margin-top: 18px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
